//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

import TableBody from 'components/Shared/TableNew/TableBody'

const MAX_WIDTH = 944
const StyledTable = styled.table`
  ${props => props.width && css`
    width: ${props.width};
    max-width: ${MAX_WIDTH}px;
  `}
`

const StyledTableBody = styled(TableBody)`
  border: 1px solid ${colors.secondary95};
`

const TableForm = ({ children, width, noBody, className }) => {
  return (
    <StyledTable
      width={width}
      className={className}
    >
      {noBody && children}
      {!noBody && (
        <StyledTableBody hoverable={false}>
          {children}
        </StyledTableBody>
      )}
    </StyledTable>
  )
}

TableForm.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
  noBody: PropTypes.bool,
}

export default TableForm
